import {addVector}      from "@Common/ui-components/image-editor/common/add-vector";
import {multiplyVector} from "@Common/ui-components/image-editor/common/multiply-vector";
import {subtractVector} from "@Common/ui-components/image-editor/common/subtract-vector";
import {chain}          from "@Common/utils/fs";

export const polygonToSvgCurvePath = (points, {radius}) => {
    let lines = [];

    for (let i = 0; i < points.length; i++) {
        const corner1 = points[i];
        const corner2 = points[(i+1)%points.length];

        lines.push({
            corner1,
            corner2,
            ...!corner1.noCurve && {
                nearPoint: getNearPoint(corner1, corner2, radius),
            },
            ...!corner2.noCurve && {
                farPoint : getFarPoint (corner1, corner2, radius),
            },
        });
    }

    let ret = [];
    for (let i = 0; i < lines.length; i++) {
        const line1 = lines[i];
        const line2 = lines[(i+1)%lines.length];

        if (i===0) {
            const p = line1.nearPoint ?? line1.corner1;
            ret.push("M" + p.x + " " + p.y);
        }
        if (line1.farPoint) {
            ret.push("L" + line1.farPoint.x + " " + line1.farPoint.y);
            ret.push("Q" + line1.corner2.x + " " + line1.corner2.y + " " + line2.nearPoint.x + " " + line2.nearPoint.y);
        } else {
            ret.push("L" + line1.corner2.x + " " + line1.corner2.y);
        }
    }
    ret.push("Z");
    return ret.join(" ");
};

const getNearPoint = (p1, p2, distance) => {
    return chain(
        subtractVector(p2, p1),
        (_) => multiplyVector(_, distance / vectorLength(_)),
        (_) => addVector(p1, _),
    );
};
const getFarPoint = (p1, p2, distance) => {
    return chain(
        subtractVector(p2, p1),
        (_) => {
            const length = vectorLength(_);
            return multiplyVector(_, (length - distance) / length);
        },
        (_) => addVector(p1, _),
    );
};

const vectorLength = (v) => Math.sqrt(v.x*v.x + v.y*v.y);
